






























import {Component, Prop, Vue} from "vue-property-decorator";
import {CarInfoModel} from "@/model/car-info/car-info.model";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";

@Component
export default class CarInfoDelete extends Vue {
    @Prop() private isVisible!: boolean;
    @Prop() private model: CarInfoModel;
    @Prop() private nextFirstCarId: string;

    /** 表示する車情報 */
    carInfo() {
        // 車両番号
        let base: string = `車両${this.model.displayId}`;
        // 付加情報
        let addition: string = [this.model.maker, this.model.type].filter(e => e).join("、");
        return addition ? `${base}（${addition}）` : base;
    }

    /** 削除 */
    deleteCarInfo() {
        // お車情報削除APIをコールする
        axios.delete(`/carinfo/${encodeURIComponent(this.model.id)}`)
            .then(cb => {
                // 削除した場合はスクロールを上部に戻す
                window.scrollTo(0, 0);

                // ダイアログをクローズする（削除したお車情報のIDと次のファーストカーのお車情報のIDを返す）
                this.$emit('close', this.model.id, cb.data.id);
            })
            .catch(error => {
                AxiosUtils.gotoClientErrorPage(error, this.$router)
            });
    }

    /** 画面の非表示 */
    close() {
        // ダイアログをクローズする
        this.$emit('close', null);
    }
}
